<template>
  <section class="container_briefing">
    <img
      class="img_briefing"
      alt="mti бот"
      src="@/assets/elements/briefing.png"
    />
    <div class="box_text_briefing">
      <h2 class="big_text color_white text_align_right">
        СВЯЗАТЬСЯ<br />
        С НАМИ
      </h2>
      <div class="container_briefing_form_main">
        <div class="container_briefing_form" :class="{ sent: isSent }">
          <input
            type="text"
            placeholder="Имя"
            class="input_briefing_footer"
            :class="{ error_input: errors.name }"
            v-model="formData.name"
            @input="onInput('name')"
            @blur="validateName"
            @keypress="filterName"
          />
          <div class="box_error_name">
            <span v-if="errors.name" class="text_error">{{ errors.name }}</span>
          </div>

          <input
            type="tel"
            placeholder="+7(999)-999-99-99"
            :class="{ error_input: errors.phone }"
            v-model="orderDetails.phone"
            @keypress="filterPhone"
            @input="handlePhoneInput($event)"
            @blur="validatePhone"
            class="input_briefing_footer"
          />
          <div class="box_error_phone">
            <span v-if="errors.phone" class="text_error">{{
              errors.phone
            }}</span>
          </div>
          <div class="box_button_v2">
            <button @click="submitForm" class="button_v1">
              Оставить заявку
            </button>
          </div>
          <div class="box_confirm_bid">
            <input
              type="checkbox"
              class="input_checkbox"
              :class="{
                active: isCheckboxActive,
                error_checkbox: !isCheckboxActive && triedToSubmit,
              }"
              @change="toggleCheckbox"
            />
            <label class="subtext_services_design color_violet">
              Согласен на обработку персональных данных Ознакомлен с
              <a
                class="underline color_violet"
                href="https://mti-dev.ru/privacy_policy.pdf"
                target="_blank"
                >политикой конфиденциальности</a
              >
            </label>
          </div>
        </div>
        <div class="container_briefing_form_sent" :class="{ sent: isSent }">
          <p class="text_small_kreadon-bold color_white text_align_center">
            Мы получили вашу заявку.<br />
            В ближайшее время мы свяжемся с вами
          </p>
          <div class="box_button_v2">
            <button class="button_v1">
              Заявка отправлена
              <img
                src="@/assets/elements/check_mark.svg"
                class="check_mark"
                alt="check_mark"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        name: "",
        phone: "",
      },
      errors: {
        name: null,
        phone: null,
      },
      touched: {
        name: false,
        phone: false,
      },
      orderDetails: {
        phone: "",
      },
      isCheckboxActive: false,
      triedToSubmit: false, // Флаг для отображения ошибки у чекбокса
      isSent: false,
      isActive: false,
    };
  },
  methods: {
    clearError(field) {
      if (this.errors[field]) {
        delete this.errors[field];
      }
    },
    handlePhoneInput(event) {
      this.formatPhone(event); // Форматируем номер телефона
      this.clearError("phone"); // Убираем ошибку, если она была
    },
    onInput(field) {
      this.touched[field] = true; // Помечаем поле как "использованное"
      this.errors[field] = null; // Помечаем поле как "было использовано"
    },
    filterName(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const allowedRegex = /^[a-zA-Zа-яА-Я\s]*$/;
      if (!char.match(allowedRegex)) {
        event.preventDefault(); // Запрещаем ввод символа
      }
    },
    validateName() {
      const nameRegex = /^[a-zA-Zа-яА-Я\s]*$/;
      if (!this.formData.name) {
        this.errors.name = "Обязательное поле";
      } else if (this.formData.name.length < 2) {
        this.errors.name = "Минимум 2 символа.";
      } else if (!this.formData.name.match(nameRegex)) {
        this.errors.name = "Имя может содержать только буквы.";
      } else {
        this.errors.name = null;
      }
    },
    filterPhone(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const allowedRegex = /^[\d+]*$/; // Разрешаем только цифры и знак "+"

      // Разрешаем удаление символов (Backspace/Delete)
      if (event.key === "Backspace" || event.key === "Delete") {
        return;
      }

      const digitsCount = this.orderDetails.phone.replace(/[^0-9]/g, "").length;
      if (!char.match(allowedRegex) || digitsCount >= 11) {
        event.preventDefault(); // Запрещаем ввод
      }
    },

    formatPhone(event) {
      // Проверяем, была ли нажата клавиша Backspace
      if (event && event.inputType === "deleteContentBackward") {
        return; // Не применяем форматирование, если происходит удаление
      }

      // Удаляем все символы, кроме цифр и "+"
      let cleaned = this.orderDetails.phone.replace(/[^0-9+]/g, "");

      // Проверяем, если поле полностью очищено, останавливаем обработку
      if (cleaned === "") {
        this.orderDetails.phone = "";
        return;
      }

      // Ограничиваем количество цифр до 11
      if (cleaned.startsWith("+7")) {
        cleaned = "+7" + cleaned.slice(2, 12); // Для номера, начинающегося с +7
      } else if (cleaned.startsWith("8")) {
        cleaned = "8" + cleaned.slice(1, 11); // Для номера, начинающегося с 8
      } else if (cleaned.startsWith("7")) {
        cleaned = "+7" + cleaned.slice(1, 11); // Для номера, начинающегося с 7
      }

      // Применяем форматирование только если длина больше 3 символов
      if (cleaned.startsWith("+7")) {
        cleaned = cleaned
          .replace(/^(\+7)(\d{0,3})/, "$1($2") // +7(XXX
          .replace(/(\(\d{3})/, (match, p1) => {
            return cleaned.length > 4 ? `${p1}) ` : p1; // Добавляем `)` и пробел
          })
          .replace(/(\)\s\d{0,3})/, "$1") // +7(XXX) YYY
          .replace(/(\s\d{3})(\d{0,2})/, "$1-$2") // +7(XXX) YYY-ZZ
          .replace(/(-\d{2})(\d{0,2})/, "$1-$2"); // +7(XXX) YYY-ZZ-WW
      } else if (cleaned.startsWith("8")) {
        cleaned = cleaned
          .replace(/^(8)(\d{0,3})/, "$1($2") // 8(XXX
          .replace(/(\(\d{3})/, (match, p1) => {
            return cleaned.length > 4 ? `${p1}) ` : p1; // Добавляем `)` и пробел
          })
          .replace(/(\)\s\d{0,3})/, "$1") // 8(XXX) YYY
          .replace(/(\s\d{3})(\d{0,2})/, "$1-$2") // 8(XXX) YYY-ZZ
          .replace(/(-\d{2})(\d{0,2})/, "$1-$2"); // 8(XXX) YYY-ZZ-WW
      }

      // Обновляем значение номера
      this.orderDetails.phone = cleaned;
    },

    validatePhone() {
      const phoneRegex = /^(\+7|8)\(\d{3}\) \d{3}-\d{2}-\d{2}$/; // Проверяем правильный формат
      if (!this.orderDetails.phone) {
        this.errors.phone = "Обязательное поле";
      } else if (!this.orderDetails.phone.match(phoneRegex)) {
        this.errors.phone = "Введите корректный номер";
      } else {
        delete this.errors.phone; // Удаляем ошибку, если валидация пройдена
      }
    },
    toggleCheckbox() {
      this.isCheckboxActive = !this.isCheckboxActive;
    },
    submitForm() {
      this.triedToSubmit = true;
      this.validateName();
      this.validatePhone();

      if (!this.errors.name && !this.errors.phone && this.isCheckboxActive) {
        // console.log({
        //   name: this.formData.name,
        //   phone: this.orderDetails.phone,
        // });
        this.sendFooterOrder();
        this.triedToSubmit = false;
        this.isSent = true;
        // alert("Форма успешно отправлена!");
      }
      //   else {
      //     alert("Пожалуйста, заполните все поля и подтвердите согласие.");
      //   }
    },
    sendFooterOrder() {
      return fetch("/api/footerFeedBack", {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=utf-8" },
        body: JSON.stringify({
          name: this.formData.name,
          phone: this.orderDetails.phone,
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          return response.data;
        });
    },
  },
};
</script>
<style scoped>
.container_briefing_form {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  width: 100%;
  height: 100%;
  position: relative;
  opacity: 1;
  transition: 0.5s ease;
}
.container_briefing_form_main {
  width: 23.6rem;
  height: 16.5rem;
  position: relative;
}
.container_briefing_form_sent {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  justify-content: center;
  opacity: 0;
  z-index: -2;
  transition: 0.5s ease;
}
.container_briefing_form_sent.sent {
  opacity: 1;
  z-index: 1;
  transition: 0.5s ease;
}
.box_error_name {
  position: absolute;
  top: 3.3rem;
  left: 3rem;
}
.box_confirm_bid {
  gap: 0.8rem;
}
.box_error_phone {
  position: absolute;
  top: 7.9rem;
  left: 3rem;
}
.input_checkbox {
  background: rgb(26, 27, 31);
  transition: 0.5s ease;
}
.check_mark {
  width: 1.1rem;
  margin-left: 1rem;
}
.error_input {
  border: 0.1rem solid #ce2f57 !important;
}
.input_checkbox.active {
  background: rgb(91, 108, 255);
  transition: 0.5s ease;
  background-image: url("@/assets/elements/check_mark.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  background-size: 1rem 1rem;
}
.input_briefing_footer {
  border: 0.08rem solid rgb(91, 108, 255, 0);
  width: 100%;
  height: 3.4rem;
  border-radius: 1.78rem;
  background: rgb(34, 36, 47);
  padding: 1.1rem 3rem;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  font-family: Kreadon-Regular;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
}
.box_button_v2 {
  width: 100%;
}
.container_briefing_form.sent {
  opacity: 0;
  transition: 0.5s ease;
}
.input_briefing_footer:hover {
  border: 0.08rem solid rgb(91, 108, 255);
  background: rgb(41, 47, 70);
  transition: 0.5s ease;
}
@media (max-width: 767px) {
  .box_text_briefing {
    width: 100%;
    gap: 1rem;
  }
  .container_briefing_form_main {
    width: 100%;
    height: fit-content;
  }
  .container_briefing_form {
    gap: 2rem;
  }
  .input_briefing_footer {
    height: 4.55rem;
    border-radius: 3.23rem;
    padding: 1.5rem 2.8rem;
    font-size: 1.27rem;
    font-weight: 400;
    line-height: 1.64rem;
  }
  .box_error_name {
    top: 4.7rem;
  }
  .box_error_phone {
    top: 11.3rem;
  }
}
</style>
